import {
  faFacebook,
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faWhatsapp,
  faXingSquare,
  faYoutube,
  faTiktok,
} from '@fortawesome/free-brands-svg-icons';

const icons = [
  faFacebook,
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faWhatsapp,
  faXingSquare,
  faYoutube,
  faTiktok,
];

export default icons;
